import { Route, Routes } from 'react-router-dom'
import { RecurringBroadcastsPage } from 'pages/broadcasts/pages/broadcasts/recurring/ui/RecurringBroadcastsPage'

export const RecurringRouter = () => {
  return (
    <Routes>
      <Route path={'/'} element={<RecurringBroadcastsPage />} />
    </Routes>
  )
}
